import React, { useEffect, useState } from 'react';
import { CTAButton } from './CTAButton';
import { ShieldCheckIcon } from 'lucide-react';
export function HeroSection() {
  const [viewers, setViewers] = useState(() => Math.floor(Math.random() * 6) + 5);
  useEffect(() => {
    const interval = setInterval(() => {
      setViewers(prev => Math.min(10, Math.max(5, prev + Math.floor(Math.random() * 5) - 2)));
    }, 8000);
    return () => clearInterval(interval);
  }, []);
  const productImage = <div className="relative w-full max-w-md aspect-square rounded-xl overflow-hidden shadow-[0_0_40px_rgba(212,168,67,0.2)] border border-brand-gold/20" data-id="element-72">
      <img src="https://cdn.magicpatterns.com/uploads/nGDmaB74Jcw9sMkZbvZa9V/Metodo_2B_bonus_1x1.png" alt="Portada El Método Sin-Tipster" className="w-full h-full object-contain" data-id="element-73" />
    </div>;
  return <section className="relative w-full min-h-[90vh] flex items-center justify-center pt-20 pb-16 px-4 overflow-hidden bg-brand-bg" data-id="element-74">
      {/* Background radial gradient */}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,rgba(212,168,67,0.15)_0%,rgba(10,14,23,1)_70%)] pointer-events-none" data-id="element-75" />

      <div className="relative z-10 max-w-6xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-76">
        <div className="flex flex-col items-center lg:items-start text-center lg:text-left space-y-8" data-id="element-77">
          <div className="space-y-4" data-id="element-78">
            <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold text-brand-gold leading-tight tracking-tight drop-shadow-lg" data-id="element-79">
              Si estás perdiendo dinero en apuestas…
            </h1>
            <h2 className="text-xl md:text-2xl text-brand-text font-medium leading-relaxed max-w-2xl" data-id="element-80">
              Deja de depender de tipsters, grupos de Telegram y picks que no
              funcionan. Aprende a analizar fútbol como un profesional y toma el
              control de tus apuestas.
            </h2>
          </div>

          {/* Mobile/tablet image - hidden on desktop */}
          <div className="lg:hidden flex justify-center w-full" data-id="element-81">
            {productImage}
          </div>

          {/* Real-time activity badge */}
          <div className="inline-flex items-center gap-2 bg-brand-card/80 backdrop-blur-sm border border-brand-gold/20 rounded-full px-4 py-2 shadow-lg" data-id="element-82">
            <span className="relative flex h-2.5 w-2.5" data-id="element-83">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-brand-green opacity-75" data-id="element-84" />
              <span className="relative inline-flex rounded-full h-2.5 w-2.5 bg-brand-green" data-id="element-85" />
            </span>
            <span className="text-sm text-brand-muted" data-id="element-86">
              ⚡ Alta demanda — 👁{' '}
              <span className="text-brand-text font-semibold" data-id="element-87">{viewers}</span>{' '}
              personas viendo ahora
            </span>
          </div>

          <div className="w-full max-w-md lg:max-w-none space-y-4" data-id="element-88">
            <CTAButton className="w-full lg:w-auto animate-pulse-slow" data-id="element-89">
              👉 ACCEDER AHORA
            </CTAButton>
            <div className="flex flex-col items-center lg:items-start gap-1" data-id="element-90">
              <span className="inline-flex items-center gap-1 bg-brand-gold/10 border border-brand-gold/30 text-brand-gold font-bold text-sm md:text-base px-4 py-1.5 rounded-full" data-id="element-91">
                🎁{' '}
                <span className="text-lg md:text-xl font-extrabold" data-id="element-92">
                  +2 BONOS
                </span>{' '}
                incluidos{' '}
                <span className="text-lg md:text-xl font-extrabold" data-id="element-93">
                  SIN COSTO
                </span>
              </span>
              <p className="text-brand-muted text-sm font-medium" data-id="element-94">
                ⏳ Disponible por tiempo limitado
              </p>
            </div>
            <div className="flex items-center justify-center lg:justify-start gap-2 text-brand-muted text-sm" data-id="element-95">
              <ShieldCheckIcon className="w-4 h-4 text-brand-green" data-id="element-96" />
              <span data-id="element-97">
                ✔ Acceso inmediato ✔ Método paso a paso ✔ Sin experiencia
                previa
              </span>
            </div>
          </div>
        </div>

        {/* Desktop image - hidden on mobile/tablet */}
        <div className="hidden lg:flex justify-center lg:justify-end" data-id="element-98">
          <div className="relative w-full max-w-lg aspect-square rounded-xl overflow-hidden shadow-[0_0_40px_rgba(212,168,67,0.2)] border border-brand-gold/20" data-id="element-99">
            <img src="https://cdn.magicpatterns.com/uploads/nGDmaB74Jcw9sMkZbvZa9V/Metodo_2B_bonus_1x1.png" alt="Portada El Método Sin-Tipster" className="w-full h-full object-contain" data-id="element-100" />
          </div>
        </div>
      </div>
    </section>;
}